<template>
    <div class="">
        <div v-if="!isAdmin" class="row">
            <div class="col-18">
                <label for="">Select an existing customer profile or create a new one by entering a customer's email
                    address. To create an order without email, click "CREATE NEW" button
                </label>
            </div>
            <div id="create-order-select" class="col-md-6">
                <SsrSelect
                    :endpoint="customersUrl"
                    :clearable="true"
                    label-key="email"
                    label="Select Customer"
                    value-key="user_id"
                    v-model=customerId
                >
                    <template #option="data">
                        <div class="d-flex flex-column mb-1">
                            <span>{{ data.data.email }}</span>
                            <small class="">{{ data.data.name }}</small>
                        </div>
                    </template>
                </SsrSelect>
            </div>
            <div class="col-md-12 d-flex gap-5 align-items-center">
                <b-button
                    variant="primary"
                    :disabled="!customerId"
                    class="text-uppercase"
                    @click="selectCustomer">Select profile
                </b-button>
                <span class="">or</span>
                <b-button
                    class="text-uppercase"
                    variant="primary"
                    :disabled="apiLoading"
                    @click="createNew">
                    <span v-if="!apiLoading">Create New Random account</span>
                    <span v-else>Creating... <b-spinner small/></span>
                </b-button>
              <b-button
                class="text-uppercase"
                variant="primary"
                :disabled="apiLoading"
                @click="createNewNormal">
                <span v-if="!apiLoading">Create New account</span>
                <span v-else>Creating... <b-spinner small/></span>
              </b-button>
            </div>
        </div>
        <div v-if="isAdmin" class="row">
            <div class="col-md-12 mb-4">
                <header-search/>
            </div>
        </div>
        <b-modal v-model="showPopup" id="email-popup" title="Enter Email"
                 hideFooter
                 centered>
          <form @submit.prevent="handleSubmit" class="p-2">
            <b-form-group label="Email:" label-for="email">
              <b-form-input id="email" v-model="customerEmail" type="email" required />
            </b-form-group>
            <b-row class="d-flex justify-content-end gap-10 p-2 m-2">
              <b-btn variant="primary" type="submit">
                <span v-if="!apiLoading">Create</span>
                <span v-else>Creating... <b-spinner small/></span>
              </b-btn>
              <b-btn variant="outline-secondary" @click="handleClose">Cancel</b-btn>
            </b-row>
          </form>
        </b-modal>
    </div>
</template>

<script>
import SsrSelect from "../../shared/SsrSelect";
import store from "../../../store";

export default {
    name: "Index",
    props: ['adminId'],
    components: {SsrSelect},
    data() {
        return {
            customerId: null,
            apiLoading: false,
            addingToCart: false,
            productId: null,
            showPopup: false,
            customerEmail: ''
        }
    },
    computed: {
        isAdmin() {
            return !!this.adminId
        },
        customersUrl() {
          return window.location.origin + "/api/customers?user_type=user&enabled=1"
        }
    },
    methods: {
        handleSubmit() {
          this.apiLoading = true
          $.ajax({
            method: 'POST',
            url: window.location.origin  + '/api/users/normal',
            data: {
              email: this.customerEmail
            }
          })
            .then((res) => {
              this.customerId = res.data.id
              this.selectCustomer()
            })
            .catch((xhr) => {
              this.$errorNotify(xhr.responseJSON.message)
            })
            .always(() => {
              this.apiLoading = false
            });
        },
        handleClose() {
            this.showPopup = false
        },
        createNewNormal() {
          this.showPopup = true
        },
        selectCustomer() {
            window.location.href = route('admin.login.customer', {id: this.customerId, createOrder: true})
        },
        createNew() {
            this.apiLoading = true
            $.ajax({
                method: 'POST',
                url: window.location.origin  + '/api/users/fake'
            })
                .then((res) => {
                    ;
                    this.customerId = res.data.id
                    this.selectCustomer()
                })
                .always(() => {
                    this.apiLoading = false
                });
        },
        addToCart() {
            this.addingToCart = true
            $.ajax({
                method: "POST",
                url: route("cart.items.store", {
                    product_id: this.productId,
                    qty: 1,
                }),
            })
                .then((cart) => {
                    store.updateCart(cart);
                    this.productId = null
                })
                .catch((xhr) => {
                  this.$errorNotify(xhr.responseJSON.message)
                })
                .always(() => {
                    this.addingToCart = false;
                });
        }
    },
}
</script>

<style scoped>
::v-deep .header-search .header-search-lg .search-input {
    color: black
}
</style>

<style lang="scss">
#create-order-select {
    .vs__dropdown-toggle {
        padding: 3px 0 6px;
    }
}
</style>
